export const arraySpreadIf = <V>(condition: boolean, value: V): V[] =>
  condition ? [value] : [];

export const objectSpreadIf = <V, K extends string>(
  condition: boolean,
  key: K,
  value: V
) => (condition ? { [key]: value } : {}) as { [k in K]?: V };
